<template>
  <div :id="componentId" class="sp2-module-2" :style="moduleStyle">
    <div class="sp2-video-card" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
      <div class="sp2-video-image-area" :style="{ backgroundColor: backgroundColor }">
        <img
          v-if="currentItem && currentItem.imageUrl"
          class="sp2-video-image"
          referrerpolicy="no-referrer"
          :src="currentItem.imageUrl"
        />
        <div v-else class="sp2-video-image-placeholder">请配置视频封面图</div>

        <img
          v-if="currentItem && currentItem.jumpUrl"
          class="sp2-play-button"
          src="@/assets/images/play-button.png"
          alt="播放"
          @click="openVideo(currentItem.jumpUrl)"
        />

        <div v-if="hasMultiple" class="sp2-video-dots">
          <span
            v-for="(item, index) in list"
            :key="index"
            :class="['sp2-dot', { active: currentIndex === index }]"
            @click.stop="goToIndex(index)"
          />
        </div>

        <div class="sp2-video-title-bar">
          <span class="sp2-video-title">{{ currentItem.title || '未设置标题' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpTwoModule2',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_2'
    }
  },
  data() {
    return {
      title: '精彩视频',
      backgroundColor: '#fff',
      list: [
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮1！'
        },
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮2！'
        },
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮3！'
        },
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮4！'
        }
      ],
      currentIndex: 0,
      timer: null
    };
  },
  computed: {
    currentItem() {
      return this.list[this.currentIndex] || null;
    },
    hasMultiple() {
      return this.list.length > 1;
    },
    canGoPrev() {
      return this.currentIndex > 0;
    },
    canGoNext() {
      return this.currentIndex < this.list.length - 1;
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  },
  mounted() {
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      if (!this.hasMultiple) return;
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.list.length;
      }, 4000);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goToIndex(index) {
      if (index < 0 || index >= this.list.length) return;
      this.currentIndex = index;
      this.stopAutoplay();
      this.startAutoplay();
    },
    goPrev() {
      if (!this.canGoPrev) return;
      this.currentIndex--;
      this.stopAutoplay();
      this.startAutoplay();
    },
    goNext() {
      if (!this.canGoNext) return;
      this.currentIndex++;
      this.stopAutoplay();
      this.startAutoplay();
    },
    openVideo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.sp2-module-2 {
  position: relative;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-video-card {
  position: relative;
  width: calc(100% - 24px);
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  background: #f5f7fa;
}

.sp2-video-image-area {
  position: relative;
  width: 100%;
  height: 52vw;
  min-height: 180px;
  max-height: 390px;
  overflow: hidden;
  border-radius: 12px;
}

.sp2-video-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-video-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #e0e0e0;
}

.sp2-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  cursor: pointer;
  z-index: 2;
  object-fit: contain;
}

.sp2-video-dots {
  position: absolute;
  bottom: 56px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 3;
}

.sp2-dot {
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp2-dot.active {
  background: #c00000;
}

.sp2-video-title-bar {
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 10px 12px;
  background: #EFF3FB;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  z-index: 4;
  box-sizing: border-box;
}

.sp2-video-title {
  flex: 1;
  font-size: 15px;
  color: #333333;
  line-height: 1.5;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
